/**
 * Remove URL-shaped segments and markdown link targets so text-to-speech never reads them aloud.
 * Structured JSON should keep canonical links in `url` only; this sanitizes any stitched playback text.
 *
 * @param {unknown} text
 * @returns {string}
 */
export function stripUrlsForTtsInput(text) {
  let s = String(text ?? '');
  // Markdown links: keep visible anchor text only
  s = s.replace(/\[([^\]]*)\]\([^)]*\)/g, '$1');
  // Angle-bracket autolinks <https://...>
  s = s.replace(/<https?:\/\/[^>\s]+>/gi, '');
  // http(s) and ftp
  s = s.replace(/\b(?:https?|ftp):\/\/[^\s)\],>]+/gi, '');
  // Scheme-less www. hostnames
  s = s.replace(/\bwww\.[^\s)\],>]+/gi, '');
  s = s.replace(/\s{2,}/g, ' ').trim();
  return s;
}
